import { defineMessages } from 'react-intl'

const messages = {
  moveReadyButton: {
    id: 'app.components.change-order-status-button.move-ready-button',
    defaultMessage: 'Move to ready',
  },
  removeButton: {
    id: 'app.components.change-order-status-button.remove-button',
    defaultMessage: 'Remove from pallet',
  },
  toInProgressButton: {
    id: 'app.components.change-order-status-button.to-in-progress-button',
    defaultMessage: 'Move to in-progress',
  },
  reason: {
    id: 'app.components.change-order-status-button.reason',
    defaultMessage: 'Moved to In-Progress',
  },
}

export default defineMessages(messages)
